<pbc-filter [config]="DurchsuchenFilterConfig" [filter]="durchsuchen.filter$ | async" (filterChange)="durchsuchen.filter$.next($event)"></pbc-filter>
